import React, { useContext, useEffect, useRef, useState } from "react";
import { context } from "../../context/context";
import { http } from "../../services/httpService";
import config from "../../services/config.json";
import {
    Avatar,
    Modal,
    Table,
    Tooltip,
    Typography,
    Badge,
    Input,
    Upload,
    message,
    Button,
    Space,
    Form,
} from "antd";
import moment from "jalali-moment";
import { toast } from "react-toastify";
import ImgCrop from "antd-img-crop";
import {
    DeleteOutlined,
    EditOutlined,
    SearchOutlined,
    UploadOutlined,
} from "@ant-design/icons";
const NoticesTable = () => {
    const [form] = Form.useForm();

    // search
    const [searchedColumn, setSearchedColumn] = useState("");
    const searchInput = useRef(null);
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
    };
    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
            close,
        }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`جستجو`}
                    value={selectedKeys[0]}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() =>
                        handleSearch(selectedKeys, confirm, dataIndex)
                    }
                    style={{
                        marginBottom: 8,
                        display: "block",
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() =>
                            handleSearch(selectedKeys, confirm, dataIndex)
                        }
                        icon={<SearchOutlined />}
                        style={{
                            width: 90,
                        }}
                    >
                        جستجو
                    </Button>
                    <Button
                        onClick={() => {
                            handleReset(clearFilters);
                            handleSearch(selectedKeys, confirm, dataIndex);
                        }}
                        style={{
                            width: 90,
                        }}
                    >
                        حذف فیلتر
                    </Button>

                    <Button
                        type="link"
                        onClick={() => {
                            close();
                        }}
                    >
                        بستن
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? "#1677ff" : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) => (searchedColumn === dataIndex ? text : text),
    });
    //persian
    const PN = require("persian-number");
    //context
    const {
        forceUpdate,
        setForceUpdate,
        isNoticeModalOpen,
        setIsNoticeModalOpen,
        fileList,
        setFileList,
        setCoverPic,
        coverPic,
        titleInput,
        setTitleInput,
        tableData,
        setTableData,
        dataInput,
        setDataInput,
    } = useContext(context);
    //states
    const [loading, setLoading] = useState(false);

    const [selectDeleteId, setSelectDeleteId] = useState();
    const [deleteModalOpen, setDeleteIsModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [selectEditId, setSelectEditId] = useState("");
    //api
    useEffect(() => {
        setLoading(true);
        http.get(`${config.parkopoloApi}/api/Interaction/Notice`)
            .then((res) => {
                setTableData(res.data.result);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
            });
    }, [forceUpdate, tableData.length]);
    // console.log(tableData);
    //functions
    const handleOk = () => {
        http.post(`${config.parkopoloApi}/api/Interaction/Notice`, {
            title: titleInput,
            data: dataInput,
            coverPic: coverPic,
        })
            .then((res) => {
                setForceUpdate(16);
                toast.success("اعلان با موفقیت ارسال شد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
                setCoverPic("");
                console.log(res);
            })
            .catch((err) => {
                setForceUpdate(15);
                toast.error("خطایی رخ داد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
                console.log(err);
            });
        setIsNoticeModalOpen(false);
        setFileList([]);
        setDataInput("");
        setForceUpdate(33);
        setTitleInput("");
    };
    const handleCancel = () => {
        setIsNoticeModalOpen(false);
    };
    const handleOkModal = () => {
        http.delete(
            `${config.parkopoloApi}/api/Interaction/Notice/${selectDeleteId}`
        )
            .then(() => {
                setForceUpdate(11);
                toast.error("اعلان با موفقیت حذف شد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
            })
            .catch((err) => {
                console.log(err);
                setForceUpdate(12);
                toast.error("خطایی رخ داد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
            });
        setDeleteIsModalOpen(false);
        setForceUpdate(150);
    };
    //upload
    const handleCancelModal = () => {
        setDeleteIsModalOpen(false);
        setEditModalOpen(false);
    };
    const handleEditModal = () => {
        http.post(
            `${config.parkopoloApi}/api/Interaction/Notice/${selectEditId}`,
            {
                title: titleInput,
                data: dataInput,
                coverPic,
            }
        )
            .then(() => {
                setForceUpdate(40);
                toast.success("اعلان با موفقیت ویرایش شد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
            })
            .catch((err) => {
                console.log(err);
                setForceUpdate(12);
                toast.error("خطایی رخ داد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
            });
        setEditModalOpen(false);
        setForceUpdate(150);
        setFileList([]);
        // setDataInput("");
    };
    const handleEdit = (record) => {
        setSelectEditId(record._id);
        setTitleInput(record.title);
        setDataInput(record.data);
        setCoverPic(record.coverPic);
    };
    const props = {
        name: "objectKey",
        action: `${config.parkopoloApi}/api/FileManager/uploadFile/?parentId=65dc777306ce9cddca15420d`,
        headers: {
            authorization: "authorization-text",
        },
        onChange(info) {
            setFileList(info.fileList);
            if (info.file.status === "done") {
                message.success(`${info.file.name} فایل با موفقیت آپلود شد`);
                setCoverPic(info.file.response.files[0]._id);
            } else if (info.file.status === "error") {
                message.error(` در آپلود فایل خطایی رخ داد!`);
            }
        },
    };

    const columns = [
        {
            title: "کاورپیک",
            dataIndex: "coverPic",
            width: "5%",
            render: (_, { coverPic }) => (
                <Avatar
                    style={{
                        width: "40px",
                        height: "40px",
                    }}
                    src={<img src={`${coverPic?.address}`} alt="cover" />}
                />
            ),
        },
        {
            title: "تعداد بازدید",
            dataIndex: "userId",
            width: "1%",
            render: (_, { userId }) => (
                <Typography.Paragraph>
                    {userId ? userId.length : "0"}
                </Typography.Paragraph>
            ),
        },
        {
            title: "عنوان اعلان",
            dataIndex: "title",
            ...getColumnSearchProps("title"),
            width: "5%",
        },

        {
            title: "متن اعلان",
            dataIndex: "data",
            width: "10%",
            render: (_, { data }) => (
                <Tooltip title={data}>
                    <div dangerouslySetInnerHTML={{ __html: data }}></div>
                </Tooltip>
            ),
        },
        {
            title: "تاریخ اعلان",
            dataIndex: "createdAt",
            width: "10%",

            render: (_, { createdAt }) => (
                <>
                    <Typography.Paragraph>
                        {PN.convertEnToPe(
                            moment(createdAt.slice(0, 10), "YYYY/MM/DD")
                                .locale("fa")
                                .format("YYYY/MM/DD")
                        )}
                    </Typography.Paragraph>
                </>
            ),
        },
        {
            title: "عملیات",
            dataIndex: "button",
            key: "button",
            width: "5%",
            render: (text, record) => (
                <>
                    <Space style={{ width: "100%", direction: "ltr" }}>
                        <Button
                            onClick={() => {
                                setDeleteIsModalOpen(true);
                                setSelectDeleteId(record._id);
                            }}
                            type="primary"
                            danger
                            shape="round"
                            icon={<DeleteOutlined />}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        />
                        <Tooltip title="ویرایش">
                            <Button
                                onClick={() => {
                                    handleEdit(record);
                                    setEditModalOpen(true);
                                }}
                                type="primary"
                                icon={<EditOutlined />}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            />
                        </Tooltip>
                    </Space>
                </>
            ),
        },
    ];
    return (
        <>
            <Table
                style={{ marginTop: "15px" }}
                size="small"
                pagination={{
                    pageSize: 10,
                    size: "default",
                    style: { position: "relative" },
                    showSizeChanger: false,
                }}
                bordered
                columns={columns}
                dataSource={tableData}
                scroll={{ x: true }}
                loading={loading}
            />
            <Modal
                title="ساخت اعلان جدید"
                open={isNoticeModalOpen}
                onCancel={handleCancel}
                okButtonProps={{ hidden: true }}
                cancelButtonProps={{ hidden: true }}
            >
                <Form
                    onFinish={handleOk}
                    layout="vertical"
                    form={form}
                    name="control-hooks"
                    style={{
                        direction: "rtl",
                        display: "flex",
                        flexDirection: "column",
                        gap: "15px",
                        // margin: "15px",
                    }}
                >
                    <Form.Item
                        style={{ marginTop: "10px" }}
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                        name="نام"
                    >
                        <Badge.Ribbon
                            placement="start"
                            style={{ marginTop: "-18px", marginRight: "10px" }}
                            text="عنوان اعلان"
                        >
                            <Input
                                value={titleInput}
                                style={{ margin: "10px", width: "80%" }}
                                placeholder="متنی بنویسید..."
                                onChange={(e) => {
                                    setTitleInput(e.target.value);
                                }}
                            />
                        </Badge.Ribbon>
                    </Form.Item>
                    <Form.Item
                        style={{ marginTop: "10px" }}
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                        name="نام"
                    >
                        <Badge.Ribbon
                            placement="start"
                            style={{ marginTop: "-18px", marginRight: "10px" }}
                            text="متن اعلان"
                        >
                            <Input
                                value={dataInput}
                                style={{ margin: "10px", width: "80%" }}
                                placeholder="متنی بنویسید..."
                                onChange={(e) => {
                                    setDataInput(e.target.value);
                                }}
                            />
                        </Badge.Ribbon>
                    </Form.Item>

                    <div style={{ marginRight: "10px", marginTop: "15px" }}>
                        <Badge.Ribbon placement="start" text="انتخاب عکس">
                            <ImgCrop
                                modalTitle="ویرایش عکس"
                                aspect={2}
                                rotationSlider
                            >
                                <Upload
                                    fileList={fileList}
                                    maxCount={1}
                                    multiple={false}
                                    {...props}
                                >
                                    <Button
                                        icon={<UploadOutlined />}
                                        style={{
                                            paddingRight: "6rem",
                                        }}
                                    >
                                        آپلود فایل
                                    </Button>
                                </Upload>
                            </ImgCrop>
                        </Badge.Ribbon>
                    </div>
                    <Form.Item>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "end",
                                gap: "10px",
                                alignItems: "center",
                            }}
                        >
                            <Button type="primary" htmlType="submit">
                                ثبت
                            </Button>
                            <Button
                                type="primary"
                                danger
                                onClick={handleCancel}
                            >
                                لغو
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </Modal>
            <Modal
                title="حذف کامل"
                open={deleteModalOpen}
                onOk={handleOkModal}
                onCancel={handleCancelModal}
                okText="حذف"
            >
                <p>مطمئنی میخوای حذف کنی؟</p>
            </Modal>
            <Modal
                title="ویرایش اعلان"
                open={editModalOpen}
                onOk={handleEditModal}
                onCancel={handleCancelModal}
                okText="ویرایش"
            >
                <div style={{ marginTop: "30px" }}>
                    <Badge.Ribbon
                        placement="start"
                        style={{ marginTop: "-18px", marginRight: "10px" }}
                        text="عنوان اعلان"
                    >
                        <Input
                            style={{ margin: "10px", width: "80%" }}
                            placeholder="متنی بنویسید..."
                            value={titleInput}
                            disabled={titleInput ? titleInput : null}
                        />
                    </Badge.Ribbon>
                </div>
                <div style={{ marginTop: "15px" }}>
                    <Badge.Ribbon
                        placement="start"
                        style={{ marginTop: "-18px", marginRight: "10px" }}
                        text="متن اعلان"
                    >
                        <Input
                            style={{ margin: "10px", width: "80%" }}
                            value={dataInput}
                            onChange={(e) => {
                                setDataInput(e.target.value);
                            }}
                        />
                    </Badge.Ribbon>
                </div>
                <div style={{ marginRight: "10px", marginTop: "15px" }}>
                    <Badge.Ribbon placement="start" text="انتخاب عکس">
                        <ImgCrop rotationSlider>
                            <Upload
                                fileList={fileList}
                                maxCount={1}
                                multiple={false}
                                {...props}
                            >
                                <Button
                                    icon={<UploadOutlined />}
                                    style={{
                                        paddingRight: "6rem",
                                    }}
                                >
                                    آپلود فایل
                                </Button>
                            </Upload>
                        </ImgCrop>
                    </Badge.Ribbon>
                </div>
            </Modal>
        </>
    );
};

export default NoticesTable;
